export const PAID_PLAN_REQUIRED_MESSAGE = 'Credit recharge is only available with an active paid plan. Join a paid plan before buying credits.';
export const SUBSCRIPTION_UNAVAILABLE_MESSAGE = 'Could not verify your paid plan. Please refresh Subscription settings and try again.';

export function getRechargeUnavailableMessage(status) {
  return status === 'unavailable' ? SUBSCRIPTION_UNAVAILABLE_MESSAGE : PAID_PLAN_REQUIRED_MESSAGE;
}

// Match the subscription service's D-003 ordering, including legacy duplicate
// rows. The newest row alone may be Free while the canonical row is paid.
export function selectCanonicalSubscription(rows) {
  const ranks = { pro: 3, basic: 2, free: 1 };
  const key = row => [Boolean(row.is_active), Boolean(row.stripe_customer_id),
    Boolean(row.stripe_subscription_id), ranks[String(row.plan_name || '').toLowerCase()] || 0,
    row.subscription_end_date || '', row.updated_at || '', row.created_at || ''];
  return [...(rows || [])].sort((a, b) => {
    const left = key(a), right = key(b);
    for (let index = 0; index < left.length; index += 1) {
      if (left[index] !== right[index]) return left[index] > right[index] ? -1 : 1;
    }
    return 0;
  })[0] || null;
}

export async function loadRechargeSubscription(client, userId) {
  const { data, error } = await client.from('subscription_info').select('*').eq('user_id', userId);
  if (error) throw error;
  if (!Array.isArray(data)) throw new Error('Could not read your subscription.');
  return selectCanonicalSubscription(data);
}

// Use the recorded plan and activation state. Billing-period expiry and
// Stripe environment reconciliation are separate from the Free-plan gate.
export function getRechargeStatus(subscription) {
  if (!subscription) return 'no_subscription';
  const tier = String(subscription.credit_tier || subscription.plan_name || '').trim().toLowerCase();
  if (tier !== 'basic' && tier !== 'pro') return 'paid_plan_required';
  // When settings has fetched Stripe, a stale active DB row cannot authorize
  // recharge. Other entry points are also checked against Stripe by checkout.
  if (Object.prototype.hasOwnProperty.call(subscription, 'billing')) {
    if (!subscription.billing?.verified) return 'unavailable';
    if (!['active', 'trialing', 'past_due'].includes(subscription.billing.status)) return 'inactive';
  }
  return subscription.is_active === true ? 'eligible' : 'inactive';
}

export function canRechargeCredits(subscription) {
  return getRechargeStatus(subscription) === 'eligible';
}
